//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { getPhoneHref } from '../../../components/helpers.js'
import { businessProcessEventsHistory } from '../../../components/BusinessProcess/BusinessProcessEvents/businessProcessEventsHistory.js'
import AddressField from '../../../components/Field/AddressField.vue'
import FilesGroup from '../../../components/File/FilesGroup.js'
import FilesField from '../../../components/File/FilesField.vue'

export default {
  components: {
    AddressField,
    FilesField
  },
  mixins: [businessProcessEventsHistory],
  props: {
    report: {
      type: Object,
      default: () => {
        return {}
      }
    },
    vehicleProvision: {
      type: Object,
      default: () => {
        return {}
      }
    },
    mobile: {
      type: Boolean,
      default: false
    },
    assignedBrigade: {
      type: Object,
      default: null
    }
  },
  data: function () {
    return {
      filesGroupAcceptance: null,
      filesGroupClosure: null
    }
  },
  computed: {
    record: function () {
      return this.vehicleProvision
    },
    phoneHref: function () {
      if (this.report.driver) {
        return getPhoneHref(this.report.driver.phone)
      }
      return null
    },
    driverEditEvent: function () {
      return this.getEventById(this.vehicleProvision.bp.driverEditEventId)
    },
    acceptanceEvent: function () {
      return this.getEventById(this.vehicleProvision.bp.acceptanceEventId)
    },
    closureEvent: function () {
      return this.getEventById(this.vehicleProvision.bp.closureEventId)
    }
  },
  watch: {
    report: {
      handler: function () {
        if (this.report) {
          if (this.report.acceptanceDocuments && this.report.acceptanceDocuments.length) {
            this.filesGroupAcceptance = new FilesGroup({
              key: 'reportDocuments',
              readonly: true
            })
            this.filesGroupAcceptance.pushFiles(this.report.acceptanceDocuments)
          } else {
            this.filesGroupAcceptance = null
          }

          if (this.report.closureDocuments && this.report.closureDocuments.length) {
            this.filesGroupClosure = new FilesGroup({
              key: 'reportDocuments',
              readonly: true
            })
            this.filesGroupClosure.pushFiles(this.report.closureDocuments)
          } else {
            this.filesGroupClosure = null
          }
        }
      },
      immediate: true
    }
  },
  methods: {
    // @Override
    isMobile () {
      return this.mobile
    },
    getEventById: function (eventId) {
      if (eventId) {
        const event = this.vehicleProvision.bp.events.find(e => e.id === eventId) || null
        return event
      }
      return null
    },
    onOpenEvent: function (event) {
      if (event != null) {
        this.onOpen(event)
      }
    },
    onOpenCard: function (event, object, type, subtypeKey) {
      if (object.id && type) {
        this.$d_showObjectCard(object.id, type, event.ctrlKey, false, subtypeKey)
      }
    },
    onCall: function (e) {
      e.navigate = false
      this.onClickLink(this.phoneHref)
    },
    onClickLink: function (href) {
      if (href) {
        const a = document.createElement('a')
        a.href = href
        a.click()
      }
    }
  }
}

